module.exports = __webpack_public_path__ + "static/media/arrow-down-black.a31f6171.svg";